import { getCookie } from 'cookies-next';

type SessionPayload = {
  usuarioid?: number | string;
  tipo?: string;
  idCandidato?: number | string;
};

function decodeBase64Url(value: string) {
  const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
  const padded = normalized.padEnd(normalized.length + ((4 - (normalized.length % 4)) % 4), '=');
  return atob(padded);
}

export function getSessionPayload(): SessionPayload | null {
  const token = getCookie('token');
  if (!token || typeof token !== 'string') return null;

  try {
    const [, payload] = token.split('.');
    if (!payload) return null;
    return JSON.parse(decodeBase64Url(payload));
  } catch {
    return null;
  }
}

export function getSessionCandidateId() {
  const payload = getSessionPayload();
  if (!payload) return null;

  if (payload.idCandidato !== undefined && payload.idCandidato !== null) {
    const candidateId = Number(payload.idCandidato);
    return Number.isNaN(candidateId) ? null : candidateId;
  }

  if (payload.tipo === 'candi') {
    const candidateId = Number(payload.usuarioid);
    return Number.isNaN(candidateId) ? null : candidateId;
  }

  return null;
}

export function getSessionUserType() {
  return getSessionPayload()?.tipo || null;
}
